import React from "react";

const ItemEnquiryShimmer = () => {
    return (
        <div className="px-[20px] py-[16px] animate-pulse">
            <div className="flex items-start justify-between gap-[12px] mb-[6px]">

                {/* LEFT */}
                <div className="flex items-center gap-[10px] min-w-0">

                    {/* Avatar */}
                    <div className="w-[36px] h-[36px] rounded-[10px] bg-[#f0f1f3]" />

                    {/* Info */}
                    <div className="min-w-0 space-y-[6px]">
                        <div className="h-[14px] w-[120px] bg-[#f0f1f3] rounded" />
                        <div className="h-[12px] w-[180px] bg-[#f0f1f3] rounded" />
                    </div>
                </div>

                {/* DATE */}
                <div className="h-[12px] w-[60px] bg-[#f0f1f3] rounded" />
            </div>

            {/* MESSAGE */}
            <div className="ml-[46px] space-y-[6px]">
                <div className="h-[12px] w-full bg-[#f0f1f3] rounded" />
                <div className="h-[12px] w-[70%] bg-[#f0f1f3] rounded" />
            </div>
        </div>
    );
};

export default ItemEnquiryShimmer;